import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import {
  railWidthCollapsed,
  railWidthExpanded,
  railTransitionDuration,
  railTransitionEasing,
} from '@/theme/customTheme';

export const useWaffleToggleStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '3rem',
    flexShrink: 0,
    backgroundColor: 'transparent',
    color: tokens.colorNeutralForegroundOnBrand,
    cursor: 'pointer',
    boxSizing: 'border-box',
    borderTopStyle: 'none',
    borderBottomStyle: 'none',
    borderLeftStyle: 'none',
    borderRightWidth: tokens.strokeWidthThin,
    borderRightStyle: 'solid',
    borderRightColor: 'rgba(255, 255, 255, 0.18)',
    transitionProperty: 'width, background-color',
    transitionDuration: railTransitionDuration,
    transitionTimingFunction: railTransitionEasing,
    ...shorthands.padding('0'),
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    ':active': {
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '-2px',
    },
    '@media (prefers-reduced-motion: reduce)': {
      transitionDuration: '0ms',
    },
  },
  rootCollapsed: {
    width: railWidthCollapsed,
  },
  rootExpanded: {
    width: railWidthExpanded,
  },
  iconColumn: {
    width: railWidthCollapsed,
    height: '100%',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    display: 'block',
  },
});
